module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("list"), _vm._v(" "), _c('div', {
    ref: "tag"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading && _vm.isDone),
      expression: "!isLoading && isDone"
    }],
    staticClass: "list-donetip"
  }, [_vm._t("doneTip", [_vm._v("没有更多数据了")])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "list-loading"
  }, [_vm._t("loadingTip", [_vm._v("加载中")])], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f711837"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfiniteScroll.vue
// module id = 606
// module chunks = 1